module.exports = __webpack_public_path__ + "img/IntelligenceFarmers.d31b3d2c.svg";